import { combineReducers } from "redux";
import productReducer from "./billing/product/product.reducer";
import dadupReducer from "./dadup/dadup.reducer";
import domainReducer from "./domain/domain.reducer";
import pbsReducer from "./pbs/pbs.reducer";
import relationReducer from "./relation/relation.reducer";
import sharedReducer from "./shared/shared.reducer";
import signUpReducer from "./sign-up/sign-up.reducer";
import qemuReducer from "./vps/qemu/qemu.reducer";

const mainReducer = combineReducers({
	dadup_state: dadupReducer,
	domain_state: domainReducer,
	pbs_state: pbsReducer,
	product_state: productReducer,
	relation_state: relationReducer,
	shared_state: sharedReducer,
	sign_up_state: signUpReducer,
	vps_qemu_state: qemuReducer,
});

const root_reducer = (state, action) => mainReducer(state, action);

export default root_reducer;
